import { render, staticRenderFns } from "./LoggedInLayout.vue?vue&type=template&id=a23c2f5a&"
import script from "./LoggedInLayout.vue?vue&type=script&lang=js&"
export * from "./LoggedInLayout.vue?vue&type=script&lang=js&"
import style0 from "./LoggedInLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports